import classNames from 'classnames';
import ImageCard from 'components/imageCard';
import { BLOG_PATHNAME } from 'constants/blog';
import Link from 'next/link';
import { Post } from 'pages/blog/types';
import { getUidWithoutLocale } from 'strapi/utils/api';

import styles from './style.module.scss';

export const PostCard = ({ post }: { post: Post }) => {
  const { image, excerpt, uid, items } = post;
  const heroBanner = items?.find(
    (item) => item.__component === 'marketing-website.hero-banner-blog'
  );
  const title = heroBanner?.title ?? post.title;

  return (
    <Link
      href={`/${BLOG_PATHNAME}/${getUidWithoutLocale(String(uid))}`}
      key={uid}
    >
      <ImageCard
        className={classNames('wmx4', styles.newsCard)}
        title={title}
        description={excerpt}
        img={{
          src: image.data?.attributes.url || '',
          alt: image.data?.attributes.alternativeText || '',
        }}
        width={288}
        height={124}
      />
    </Link>
  );
};
